import { SpeakerV2InfoForm } from "./SpeakerV2InfoForm";

export default SpeakerV2InfoForm;
